import styles from './index.module.scss'

/**
 * @param {'default' | 'compact' | 'emailReply'} variant
 * @param {{ isComposerVariant: boolean, isEmailReply: boolean }} vm
 * @param {'home' | 'thread' | 'page' | undefined} contentWidth
 */
export function buildAiAskBarRootClassName(variant, vm, contentWidth) {
  const useHomeShell = !vm.isComposerVariant
  const widthClass =
    contentWidth === 'thread'
      ? styles.askBarRootThread
      : contentWidth === 'page'
        ? styles.askBarRootPage
        : useHomeShell
          ? styles.askBarRootHome
          : ''

  return [styles.askBarRoot, widthClass, vm.isEmailReply ? styles.askBarRootEmailReply : '']
    .filter(Boolean)
    .join(' ')
}
